import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdministradoraEditarComponent } from './administradora-editar.component';




@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: AdministradoraEditarComponent }    
    ])],
    exports: [RouterModule]
})
export class AdministradoraEditarRoutingModule { }
